const initialState = {
  userTransDownloadRes: null,
  transDownloadLoader: false,
  addReferrerResponse: null,
};
const SettingReducer = (state = initialState, action) => {
  switch (action.type) {
    case "USER_TRANS_DOWNLOAD_RESPONSE":
      return { ...state, userTransDownloadRes: action.payload };
    case "SHOW_TRANS_DOWNLOAD_LOADER":
      return { ...state, transDownloadLoader: true };
    case "HIDE_TRANS_DOWNLOAD_LOADER":
      return { ...state, transDownloadLoader: false };
    case "ADD_REFERRER_RESPONSE":
      return { ...state, addReferrerResponse: action.payload };
    default:
      return state;
  }
};

export default SettingReducer;
